import React from 'react';
export const GeneratingView = ({ text }) => {
    return (
        <div className='w-full flex justify-center items-center my-2 drop-shadow animate-pulse text-texts-tertiary'>
            {text}
        </div>
    );
};